export enum Roles {
    ADMIN = 'ADMIN',
    MENTOR = 'MENTOR',
    STARTUP = 'STARTUP'
}
